// ======================================================================
// FILE:
// src/modules/service_crm/feedback/components/FeedbackFormDrawer.js
//
// MODULE: Service CRM
//
// FEATURE:
// Feedback Drawer
// ======================================================================

import React from "react";

import CustomerFeedbackSection
from "../../tickets/components/CustomerFeedbackSection";

export default function FeedbackFormDrawer({

  open,

  mode = "add",

  ticket,

  onClose,

  onSaved,

}) {

  if (!open || !ticket) {
    return null;
  }

  const readOnly =
    mode === "view";

  return (

    <>

      {/* BACKDROP */}

      <div

        onClick={onClose}

        style={{

          position: "fixed",

          top: 0,

          left: 0,

          right: 0,

          bottom: 0,

          background:
            "rgba(0,0,0,0.45)",

          zIndex: 999,
        }}
      />

      {/* DRAWER */}

      <div

        style={{

          position: "fixed",

          top: 0,

          right: 0,

          width: "900px",

          maxWidth: "95vw",

          height: "100vh",

          background: "#fff",

          overflowY: "auto",

          zIndex: 1000,

          boxShadow:
            "-2px 0 12px rgba(0,0,0,0.15)",
        }}
      >

        {/* HEADER */}

        <div

          style={{

            padding: "20px",

            borderBottom:
              "1px solid #dee2e6",

            display: "flex",

            justifyContent:
              "space-between",

            alignItems:
              "center",
          }}
        >

          <div>

            <h4
              style={{
                margin: 0,
              }}
            >

              Customer Feedback

            </h4>

            <div
              style={{
                color: "#6c757d",
                marginTop: 4,
              }}
            >

              {ticket.ticket_no}

            </div>

          </div>

          <button

            className="btn btn-outline-secondary"

            onClick={onClose}
          >
            Close
          </button>

        </div>

        {/* TICKET SUMMARY */}

        <div
          style={{
            padding: 20,
          }}
        >

          <div className="row">

            <div className="col-md-3">

              <div
                className="card"
              >
                <div
                  className="card-body"
                >
                  <small>
                    Ticket No
                  </small>

                  <div>
                    <b>
                      {
                        ticket.ticket_no
                      }
                    </b>
                  </div>
                </div>
              </div>

            </div>

            <div className="col-md-3">

              <div
                className="card"
              >
                <div
                  className="card-body"
                >
                  <small>
                    Customer
                  </small>

                  <div>
                    <b>
                      {
                        ticket.customer_name
                      }
                    </b>
                  </div>
                </div>
              </div>

            </div>

            <div className="col-md-3">

              <div
                className="card"
              >
                <div
                  className="card-body"
                >
                  <small>
                    Engineer
                  </small>

                  <div>
                    <b>
                      {
                        ticket.assigned_engineer
                      }
                    </b>
                  </div>
                </div>
              </div>

            </div>

            <div className="col-md-3">

              <div
                className="card"
              >
                <div
                  className="card-body"
                >
                  <small>
                    Resolved Date
                  </small>

                  <div>
                    <b>

                      {ticket.resolved_at
                        ? new Date(
                            ticket.resolved_at
                          ).toLocaleDateString()
                        : "-"}

                    </b>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>

        {/* FEEDBACK FORM */}

        <div
          style={{
            padding:
              "0 20px 20px",
          }}
        >

          <CustomerFeedbackSection

            ticketId={
              ticket.ticket_id
            }

            ticketStatus={
              readOnly
                ? "CLOSED"
                : "RESOLVED"
            }

            onSaved={() => {

              if (onSaved) {
                onSaved();
              }

            }}

          />

        </div>

      </div>

    </>

  );
}